import PropTypes from 'prop-types';
import React, { ComponentType } from 'react';

import Div from '../../Element/Div/Div';

import styles from './InputMessage.module.scss';
import BodyText from '../../Typography/BodyText/BodyText';
import { SupportedTextColor } from '../../Typography/Typography';

type InputMessageProps = {
  text: string;
  color: SupportedTextColor;
};

const InputMessage: ComponentType<InputMessageProps> = ({ text, color }) => {
  return (
    <Div className={styles.inputMessage}>
      <Div
        padding={{ top: 'xs', right: 'xs' }}
        className={styles.inputMessage_textContainer}
      >
        <BodyText
          tagName="span"
          block
          size="sm"
          color={color}
          className={styles.inputMessage_text}
        >
          {text}
        </BodyText>
      </Div>
    </Div>
  );
};

InputMessage.propTypes = {
  /** Error text shown */
  text: PropTypes.string.isRequired,
};

export default InputMessage;
